import type { IconName } from '../N8nIcon/icons';

export const ALL_ICON_PICKER_ICONS: IconName[] = [
	'folder-plus',
	'share',
	'user-check',
	'check-check',
	'circle',
	'eye-off',
	'folder',
	'circle-minus',
	'contrast',
	'refresh-cw',
	'vault',
	'chevrons-left',
	'archive',
	'arrow-left',
	'arrow-right',
	'arrow-up',
	'arrow-down',
	'at-sign',
	'ban',
	'scale',
	'menu',
	'zap',
	'book',
	'package-open',
	'bug',
	'brain',
	'calculator',
	'calendar',
	'chart-column-decreasing',
	'check',
	'circle-check',
	'square-check',
	'chevron-left',
	'chevron-right',
	'chevron-down',
	'chevron-up',
	'code',
	'git-branch',
	'cog',
	'message-circle',
	'messages-square',
	'clipboard-list',
	'clock',
	'copy',
	'cloud',
	'cloud-download',
	'files',
	'box',
	'scissors',
	'database',
	'circle-dot',
	'grip-lines-vertical',
	'grip-vertical',
	'square-pen',
	'ellipsis',
	'ellipsis-vertical',
	'mail',
	'equal',
	'eye',
	'triangle-alert',
	'maximize',
	'maximize-2',
	'mcp',
	'external-link',
	'arrow-left-right',
	'file',
	'file-text',
	'file-archive',
	'file-code',
	'file-down',
	'file-output',
	'file-input',
	'file-text',
	'funnel',
	'fingerprint',
	'flask-conical',
	'folder-open',
	'case-upper',
	'gift',
	'globe',
	'earth',
	'graduation-cap',
	'hand-coins',
	'scissors',
	'handshake',
	'arrow-left',
	'hash',
	'hard-drive',
	'history',
	'house',
	'hourglass',
	'image',
	'inbox',
	'info',
	'key-round',
	'languages',
	'layers',
	'link',
	'list',
	'lightbulb',
	'lock',
	'milestone',
	'mouse-pointer',
	'network',
	'palette',
	'pause',
	'circle-pause',
	'pen',
	'pencil',
	'play',
	'circle-play',
	'plug',
	'plus',
	'circle-plus',
	'square-plus',
	'waypoints',
	'circle-help',
	'circle-help',
	'redo-2',
	'remove-formatting',
	'bot',
	'rss',
	'save',
	'satellite-dish',
	'search',
	'zoom-out',
	'zoom-in',
	'server',
	'pocket-knife',
	'smile',
	'log-in',
	'log-out',
	'sliders-horizontal',
	'sticky-note',
	'square',
	'align-right',
	'sun',
	'refresh-cw',
	'table',
	'tags',
	'list-checks',
	'terminal',
	'grid-2x2',
	'pin',
	'thumbs-down',
	'thumbs-up',
	'x',
	'circle-x',
	'wrench',
	'trash-2',
	'undo-2',
	'unlink',
	'user',
	'circle-user-round',
	'user-round',
	'users',
	'video',
	'tree-pine',
	'user-lock',
	'gem',
	'hard-drive-download',
	'power',
	'send',
	'bell',
	'variable',
	'pop-out',
	'triangle',
	'status-completed',
	'status-waiting',
	'status-error',
	'status-canceled',
	'status-new',
	'status-unknown',
	'status-warning',
	'vector-square',
	'schema',
	'json',
	'binary',
	'text',
	'toolbox',
	'spinner',
];
